import { render, staticRenderFns } from "./GroupAccessEditSmall.vue?vue&type=template&id=e76ea67c&scoped=true&"
import script from "./GroupAccessEditSmall.vue?vue&type=script&lang=ts&"
export * from "./GroupAccessEditSmall.vue?vue&type=script&lang=ts&"
import style0 from "./GroupAccessEditSmall.vue?vue&type=style&index=0&id=e76ea67c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76ea67c",
  null
  
)

export default component.exports